export class SearchCondition {
    subject_code: string = ""
    subject_name: string = ""
    page: number = 1
    row_count: number =  100
  }
  
  export class SchoolSubject {
    id: number
    subject_code: number
    subject_name: string
    full_count: number
    is_checked: boolean = false
  
    constructor(x: any){
      this.id = x.id;
      this.subject_code = x.subject_code;
      this.subject_name = x.subject_name;
      this.full_count = x.full_count;
    }
  }